import { createFileRoute } from '@tanstack/react-router'
import { TrackerDetailView } from '@/features/tracker/TrackerDetailView'

function TrackerDetail() {
  const { id } = Route.useParams()
  const { asUser } = Route.useSearch()
  return <TrackerDetailView ticketId={id} asUser={asUser} />
}

export const Route = createFileRoute('/tracker/$id')({
  // Keeps the lens active when clicking through from a lensed tracker list.
  validateSearch: (raw: Record<string, unknown>): { asUser?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined,
  }),
  component: TrackerDetail,
})
